import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const drawLabelsPlugin = {
  id: "drawLabelsPlugin",
  afterDatasetsDraw: (chart) => {
    const { ctx, data } = chart;
    if (!ctx || !data?.datasets?.length) {
      return;
    }
    const meta = chart.getDatasetMeta(0);
    const dataset = data.datasets[0];
    if (!meta?.data || !dataset?.data) {
      return;
    }
    ctx.save();
    ctx.font = "600 10px 'Source Serif 4', serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    meta.data.forEach((arc, index) => {
      const value = Number(dataset.data[index]);
      if (!Number.isFinite(value) || value < 5) {
        return;
      }
      const angle = (arc.startAngle + arc.endAngle) / 2;
      const radius = (arc.innerRadius + arc.outerRadius) / 2;
      const x = arc.x + Math.cos(angle) * radius;
      const y = arc.y + Math.sin(angle) * radius;
      const isSimulated = chart.$variant === "simulated";
      ctx.fillStyle = isSimulated ? "#1A2B5F" : "#ffffff";
      ctx.fillText(`${value.toFixed(0)}%`, x, y);
    });

    ctx.restore();
  },
};

export default function AnalyticsAssetPoolCharts({
  allocation,
  variant = "current",
}) {
  const chartRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const rows = Array.isArray(allocation) ? allocation : [];
    const labels = rows.map((item) => item.label);
    const values = rows.map((item) => item.value);
    const colors = rows.map((item) => item.color);
    console.log("Asset pool ring data:", { variant, values, labels });

    const canvasId = variant === "simulated" ? "simulatedAssetChart" : "currentAssetChart";
    const canvas = document.getElementById(canvasId);
    if (!canvas) {
      return;
    }
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }

    if (chartRef.current) {
      const chart = chartRef.current;
      chart.data.labels = labels;
      if (chart.data.datasets[0]) {
        chart.data.datasets[0].data = values;
        chart.data.datasets[0].backgroundColor = colors;
      }
      chart.$variant = variant;
      chart.update("none");
      return;
    }

    chartRef.current = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
            borderWidth: 0,
            cutout: "60%",
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: "#1a2b5f",
            titleColor: "#ffffff",
            bodyColor: "#ffffff",
            displayColors: true,
            callbacks: {
              label: (context) => {
                const value = Number(context.parsed);
                if (!Number.isFinite(value)) {
                  return "";
                }
                return `${context.label}: ${value.toFixed(2)}%`;
              },
            },
          },
        },
      },
      plugins: [drawLabelsPlugin],
    });
    chartRef.current.$variant = variant;
  }, [allocation, variant]);

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ position: "relative", height: "220px", width: "220px" }}>
      <canvas
        id={variant === "simulated" ? "simulatedAssetChart" : "currentAssetChart"}
      />
    </div>
  );
}
